<template>
    <div class="notice">
        <!--<Header/>-->
        <div class="box">
            <img :src="require('../assets/tu18.jpg')" class="img">
            <div class="propaganda">
                <p class="title_one">受人尊敬，员工满意的勘测行业领军者；</p>
                <p class="title_two">价值共创、值得信赖的城乡发展综合服务商</p>
            </div>

<!--            <el-carousel class="carousel" height="580px" :interval="3000">-->
<!--                <el-carousel-item v-for="(item ,index) in imgList" :key="item">-->
<!--                    <img :src=item class="img">-->
<!--                    <p class="slogan">{{sloganList[index]}}</p>-->
<!--                </el-carousel-item>-->
<!--            </el-carousel>-->
        </div>
        <!--<div class="banner">-->
        <!--<img src="../assets/homeBanner.jpg" class="img">-->
        <!--<p class="slogan">为顾客规避风险，创造价值</p>-->
        <!--</div>-->

        <div class="content">
            <h2>公告</h2>
            <div>
                <p>2022年应届毕业生招聘已于2021年10月15日结束，春季招聘工作将于2021年11月启动，具体招收专业及人数另行公布，求职者可于11月份关注企业官网（<a href="http://www.bgi.com.cn" target="_blank">www.bgi.com.cn</a>），进行线上简历投递。</p>
                <p>联系人：苏老师、丁老师　　联系电话：010-63951970</p>
                <div class="bottom_box">
                    <div>人力资源部</div>
                    <div>2021年10月15日</div>
                </div>

            </div>
        </div>
        <Footer/>
    </div>

</template>

<script>
    import Header from '../base/Header'
    import Footer from '../base/Footer'
    import tu1 from '../assets/tu1.jpg'
    import tu2 from '../assets/tu2.jpg'
    import tu3 from '../assets/tu3.jpg'
    import tu4 from '../assets/tu4.jpg'
    import tu5 from '../assets/tu5.jpg'
    import tu6 from '../assets/tu6.jpg'
    import tu8 from '../assets/tu8.jpg'
    import tu9 from '../assets/tu9.jpg'
    import tu10 from '../assets/tu10.jpg'
    import tu11 from '../assets/tu11.jpg'
    import tu14 from '../assets/tu14.jpg'
    import tu15 from '../assets/tu15.jpg'
    import tu17 from '../assets/tu17.jpg'
    import tu18 from '../assets/tu18.jpg'

    import {getRecruitList} from '../api';

    import { list } from './data.js';
    import { merge, spanMethod} from './mergeClass'


    export default {
        name: 'Home',
        props: {},
        components: {Header, Footer},
        data() {
            return {
                total: 0,
                page: 1,
                pageSize: 20,
                height: '300px',
                imgList: [
                    tu18,
                    // tu11,
                    // tu5,
                    // tu3,
                    // tu4,
                    // tu8,
                ]
            }
        },
        created() {

        },
        methods: {




        },


    }
</script>

<style scoped lang="less">
    .notice {
        width: 100%;
        position: relative;
        background-color: #fff;

        .content {
            margin: 50px auto 60px;
            width: 1000px;
            background: #fff;
            overflow: hidden;
            h2 {
                font-size: 37px;
                margin: 35px 0 30px;
                letter-spacing: 8px;
                font-weight: 700;
                /*color: #102b6a;*/
                color: red;
            }
            .label{
                text-align: left;
                font-weight: 600;
                font-size: 18px;
                margin-bottom: 30px;
                margin-top: 30px;
            }

            p {
                line-height: 45px;
                text-align: left;
                text-indent: 35px;
                font-size: 18px;
                /*font-family: '仿宋';*/
                color: #000000;
                a{
                    color: #102b6a;
                }
            }
            .lianxiren{
                letter-spacing: 5px;

            }
            .bottom_box{
                display: inline-block;
                text-align: center;
                width: 160px;
                margin-top: 40px;
                margin-bottom: 10px;
                font-size: 18px;
                float: right;
                /*font-family: '仿宋';*/
                color: #000000;
                div{
                    margin-bottom: 10px;
                }
            }
        }


        img {
            width: 100%;
            height: 100%;
        }

        .box{
            width: 100%;height: 600px;
            position: relative;
        }
        .propaganda{
            position: absolute;
            z-index: 2;
            top: 45%;
            right: 0;
            /*left: 50%;*/
            font-size: 45px;
            line-height: 80px;
            text-align: left;
            width: 900px;
            color: #FFF;
            font-family: 华文新魏;
            text-shadow: 5px 5px 5px #00497f;
        }
        .title_one{

        }
        .title_two{
            /*top: 50%;*/
            /*left: 50%;*/
        }

        .slogan {
            position: absolute;
            z-index: 2;
            top: 40%;
            left: 50%;
            font-size: 58px;
            line-height: 80px;
            text-align: left;
            width: 700px;
            color: #FFF;
            font-family: 华文新魏;
            text-shadow: 5px 5px 5px #00497f;
        }

    }


</style>
<style lang="less">

</style>